import { AfterViewInit, Component, Inject, OnDestroy, OnInit } from '@angular/core';

import { PitchPlaylistQuery } from './shared/pitch-playlist/state';
import { PitchService } from './external-pitch/pitch.service';
import { Subscription } from 'rxjs';
import { UserDivision } from './shared/types';
import { filter } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';
import { PitchPageMetaService } from './pitch-page-meta.service';

@Component({
  selector: 'pitch-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  pitch$ = this.query.pitchInfo$;
  pitchNotFound$ = this.query.selectPitchNotFound$;
  loading$ = this.query.selectLoading$;
  preRenderedContent = this.document.querySelector('.pre-rendered-content');

  userDivision: UserDivision = null;

  subscription: Subscription = new Subscription();

  constructor(
    private query: PitchPlaylistQuery,
    private pitches: PitchService,
    private metaService: PitchPageMetaService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this.pitches.fetchAll().subscribe(_ => {
        this.preRenderedContent.classList.add('hidden');
      })
    );

    this.subscription.add(
      this.pitch$.pipe(filter(pitch => Boolean(pitch.id))).subscribe(pitch => {
        const { userDivision = UserDivision.WMG } = pitch;
        this.userDivision = userDivision as UserDivision;
        this.metaService.setMeta(this.userDivision);
      })
    );
  }

  ngAfterViewInit() {}

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
